import type { Tone } from '../../components/StatusBadge';
import type { AuthedRequest } from '../auth/AuthProvider';

/** Mirrors GET /api/v1/system/services (requires system.read). */
export interface ContainerState {
  /** Docker state: created, running, paused, restarting, removing, exited, dead. */
  state: string;
  health: 'healthy' | 'unhealthy' | 'starting' | null;
  started_at: string | null;
  restart_count: number;
  image: string;
}

export interface ServiceInfo {
  name: string;
  version: string | null;
  container: ContainerState | null;
}

export interface ServicesReport {
  /** 'disabled' when no Docker API proxy is configured (e.g. Kubernetes). */
  docker: 'ok' | 'unavailable' | 'disabled';
  checked_at: string;
  items: ServiceInfo[];
}

export const servicesKey = ['system', 'services'] as const;

export const getServices = (req: AuthedRequest) =>
  req<ServicesReport>('GET', '/api/v1/system/services');

/** What each component does, shown under its name. */
export const serviceRoles: Record<string, string> = {
  api: 'Plano de controle',
  media: 'Servidor de mídia',
  postgres: 'Banco de dados',
  redis: 'Sessões e cache',
  nats: 'Barramento de eventos',
};

/** Container state as an operator reads it; always text plus tone. */
export function containerView(c: ContainerState): { tone: Tone; label: string } {
  switch (c.state) {
    case 'running':
      if (c.health === 'unhealthy') return { tone: 'crit', label: 'Não saudável' };
      if (c.health === 'starting') return { tone: 'neutral', label: 'Iniciando' };
      return { tone: 'ok', label: c.health === 'healthy' ? 'Saudável' : 'Em execução' };
    case 'restarting':
      return { tone: 'warn', label: 'Reiniciando' };
    case 'paused':
      return { tone: 'warn', label: 'Pausado' };
    case 'created':
      return { tone: 'neutral', label: 'Criado' };
    default:
      return { tone: 'crit', label: 'Parado' };
  }
}
